const NZElectricSafety = () => {
  return (
    <div className="bg-white pt-[60px] pb-[60px]">
      <div className="custom-container px-[30px] text-start mx-auto ">
        <div className="max-w-[1200px]  mx-auto">
          <div className="space-y-10">
            <div>
              <h3 className="text-2xl kuunari-bold text-gray-800 mb-5 text-center ">Battery Charging & Support</h3>
              <p className="text-gray-600 text-base leading-7 text-center">
                Each vehicle comes with its own charge cable and can be plugged into standard 3-pin single-phase wall sockets.   With our latest eTuarara models, we have the ability to carry out remote diagnosis on the battery. This allows us to examine the battery health from literally anywhere and even carry out software updates remotely.
              </p>
            </div>

            <div>
              <h3 className="text-2xl kuunari-bold text-gray-800 mb-5 text-center ">Safety</h3>
              <p className="text-gray-600 text-base leading-7 text-center">
                <span>
                  The eTuatara  is fitted with 2x retractable sash-type seatbelts and a lap-belt for the middle seat passenger. The eTuatara is also equipped with a certified rollover protective structure (ROPS). The passenger cabin may also be fully enclosed  with the installation of an accessory glass windscreen  (i.e. opening) with a wiper and washer, as well as a rear enclosure with window and full-length or half doors.
                </span>
                <br />
                <br />
                <span>
                  Tuatara strongly believes that EV's are a great option, especially for farming, and believe that there will soon be a day when electric vehicles in farming will be the norm, rather than the exception.
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default NZElectricSafety;
